import { Navigate } from "react-router-dom";

export default function Novita() {
  return <Navigate to="/lavori?tab=novita" replace />;
}
